import { Injectable } from '@angular/core';
import { IMappedEntityModel } from '../../../models/project/mapped-entity.model';
import { IWorkspaceInstanceModel } from '../../../models/workspace/workspace-instance.model';
import { NodeInstanceModel } from '../../../models/node/node-instance.model';
import { BlueprintStore } from '../../../services/stores/blueprint.store';

@Injectable({
  providedIn: 'root',
})
export class EditPanelTargetMapHelperService {
  constructor(private blueprintStore: BlueprintStore) {}

  public filterAvailableMaps(query: string, sourceList: IMappedEntityModel[] = [], selectedList: IMappedEntityModel[] = []): IMappedEntityModel[] {
    if (!sourceList) {
      return [];
    }
    const normalizedQuery = query?.toLowerCase?.() ?? '';
    return sourceList.filter((map) => {
      const matchesQuery = !normalizedQuery || map.name?.toLowerCase?.().includes(normalizedQuery) || map.path?.toLowerCase?.().includes(normalizedQuery);
      const alreadySelected = selectedList?.some((selected) => selected.id === map.id);
      return matchesQuery && !alreadySelected;
    });
  }

  public addSelection(current: IMappedEntityModel[], map: IMappedEntityModel | null | undefined): IMappedEntityModel[] {
    if (!map) {
      return current;
    }
    return [...(current ?? []).filter((item) => item.id !== map.id), map];
  }

  public removeSelection(current: IMappedEntityModel[], map: IMappedEntityModel | null | undefined): IMappedEntityModel[] {
    if (!map) {
      return current;
    }
    return (current ?? []).filter((item) => item.id !== map.id);
  }

  public persistSelection(params: {
    selectedWorkspace: IWorkspaceInstanceModel | null | undefined;
    selectedNode: NodeInstanceModel | null | undefined;
    formData: { [fieldId: string]: any };
    fieldName: string;
    selectedMaps: IMappedEntityModel[];
  }): void {
    if (!params) {
      return;
    }
    const targetField = this.blueprintStore
      .getBlueprintByIdFromCache(params.selectedWorkspace?.bluePrintId)
      ?.fields?.find((field) => field.name?.toLocaleLowerCase?.().trim() === params.fieldName.toLocaleLowerCase?.().trim());
    if (!targetField) {
      return;
    }
    const ids = (params.selectedMaps ?? []).map((map) => map.id).join(',');
    params.formData[targetField.id] = ids;
    if (params.selectedNode?.fields) {
      params.selectedNode.fields[targetField.id] = ids;
    }
  }
}
